export default {
  header: 'Event tags',
  empty: 'No event tags have been created yet.',
  confirmDelete: 'Are you sure you want to delete "{item}"? Events already carrying this tag keep it.',
};
